"use client";

import useGetCCPAFooter from "rivals/services/getCCPAFooter/useGetCCPAFooter";
import { useCompliance } from "rivals/shared/useCompliance";

export default function Compliance(): null {
  const { data: footerConstants } = useGetCCPAFooter();

  useCompliance(footerConstants);

  return null;
}
